import { ConvertPointsDialogContentContainer } from './ConvertPointsDialogContentContainer'
import { CommonDialogProps, DialogConfig } from '@/features/dialogs/common/types'
import { Dialog, DialogContent } from '@/ui/atoms/dialog/Dialog'

export type ConvertPointsDialogProps = CommonDialogProps & {
  onSuccess: (() => void) | undefined
}

function ConvertPointsDialog({ open, setOpen, onSuccess }: ConvertPointsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <ConvertPointsDialogContentContainer onSuccess={onSuccess} closeDialog={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  )
}

export const convertPointsDialogConfig: DialogConfig<ConvertPointsDialogProps> = {
  options: {
    closeOnAccountChange: true,
  },
  element: ConvertPointsDialog,
  name: 'ConvertPointsDialog',
} satisfies DialogConfig<ConvertPointsDialogProps>
